import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaFileInvoiceDollar, FaFileContract, FaSyncAlt, FaWpforms } from 'react-icons/fa';

// Zentrale Uebersicht aller systemseitig gepflegten, wiederverwendbaren Vorlagen
// ("Systemtemplates"). Jede Kachel verlinkt auf die bereits bestehende
// Implementierung der jeweiligen Vorlage/Funktion (additiv, keine Logikaenderung).
const SYSTEM_DOCUMENTS = [
  {
    key: 'rechnung',
    title: 'Rechnung',
    description: 'System-Belegarten (Rechnungen/Belege) mit EJS-Vorlagen verwalten.',
    icon: FaFileInvoiceDollar,
    to: '/system-document-types',
    accent: '#007AFF',
  },
  {
    key: 'vereinbarungen',
    title: 'Vereinbarungen',
    description: 'System-Vereinbarungsvorlagen (Titel, Inhalt, Stufen-Sichtbarkeit) verwalten.',
    icon: FaFileContract,
    to: '/system-agreement-templates',
    accent: '#34C759',
  },
];

const SYSTEM_TOOLS = [
  {
    key: 'placeholder-sync',
    title: 'Platzhalter synchronisieren',
    description: 'Verfuegbare Platzhalter fuer die Vorlagen aktualisieren/abgleichen.',
    icon: FaSyncAlt,
    to: '/placeholder-sync',
    accent: '#AF52DE',
  },
  {
    key: 'form-templates',
    title: 'Formular-Vorlagen',
    description: 'Generische Formular-Templates (Felder/Struktur) zentral pflegen.',
    icon: FaWpforms,
    to: '/form-templates',
    accent: '#FF9500',
  },
];

const BoardSystemTemplates = () => {
  const navigate = useNavigate();

  const renderCard = (item) => {
    const Icon = item.icon;
    return (
      <Col xs={12} sm={6} xl={4} key={item.key} className="mb-4">
        <Card
          role="button"
          tabIndex={0}
          aria-label={item.title}
          className="myn-systpl-card h-100"
          onClick={() => navigate(item.to)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              navigate(item.to);
            }
          }}
        >
          <Card.Body className="d-flex align-items-start">
            <span className="myn-systpl-icon" style={{ backgroundColor: `${item.accent}1A`, color: item.accent }}>
              <Icon size={26} aria-hidden="true" />
            </span>
            <div className="ms-3">
              <Card.Title className="mb-1 myn-systpl-title">{item.title}</Card.Title>
              <Card.Text className="myn-systpl-desc">{item.description}</Card.Text>
            </div>
          </Card.Body>
        </Card>
      </Col>
    );
  };

  return (
    <Container className="myn-systpl-page py-4">
      <style>{`
        .myn-systpl-page { max-width: 1200px; }
        .myn-systpl-header { font-weight: 700; color: #1d1d1f; margin-bottom: 6px; }
        .myn-systpl-intro { color: #6e6e73; margin-bottom: 28px; }
        .myn-systpl-section-title {
          font-size: 14px; font-weight: 600; letter-spacing: .04em;
          text-transform: uppercase; color: #8a8a8e; margin: 8px 0 14px;
        }
        .myn-systpl-card {
          border: 1px solid #ececec; border-radius: 16px; cursor: pointer;
          transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
          box-shadow: 0 2px 10px rgba(0,0,0,.05);
        }
        .myn-systpl-card:hover, .myn-systpl-card:focus-visible {
          transform: translateY(-3px); box-shadow: 0 10px 28px rgba(0,0,0,.12);
          border-color: #d8d8d8; outline: none;
        }
        .myn-systpl-icon {
          display: inline-flex; align-items: center; justify-content: center;
          width: 52px; height: 52px; border-radius: 14px; flex: 0 0 auto;
        }
        .myn-systpl-title { font-size: 18px; font-weight: 600; color: #1d1d1f; }
        .myn-systpl-desc { font-size: 14px; color: #6e6e73; margin-bottom: 0; }
        @media (max-width: 575.98px) {
          .myn-systpl-icon { width: 44px; height: 44px; border-radius: 12px; }
          .myn-systpl-title { font-size: 16px; }
        }
      `}</style>

      <h1 className="myn-systpl-header">Systemtemplates</h1>
      <p className="myn-systpl-intro">
        Zentrale Verwaltung aller wiederverwendbaren System-Vorlagen. Waehlen Sie eine
        Vorlage aus, um deren bestehende Verwaltungsansicht zu oeffnen.
      </p>

      <div className="myn-systpl-section-title">System-Dokumente</div>
      <Row>
        {SYSTEM_DOCUMENTS.map(renderCard)}
      </Row>

      <div className="myn-systpl-section-title">Werkzeuge</div>
      <Row>
        {SYSTEM_TOOLS.map(renderCard)}
      </Row>
    </Container>
  );
};

export default BoardSystemTemplates;
